import { hideSnackbar, showSnackbar } from "../Redux/Actions/SnackbarActons";
import { useDispatch } from "react-redux";

const useSnackbar = () => {
    const dispatch = useDispatch();

    const showSnackBar = (message, severity) => {
        dispatch(showSnackbar(message, severity));
    };

    const hideSnackBar = () => {
        dispatch(hideSnackbar());
    };

    return { showSnackBar, hideSnackBar };
};

export default useSnackbar;
